import { NullableUndefinedString } from "../types/nullable-types";

const toSlug = (id: string) => id.trim().toLowerCase().replaceAll(" ", "-");

export const testId = (id: NullableUndefinedString) => {

    if(!id) {
        return {};
    }

    return process.env.REACT_APP_ENABLE_TESTID === "true"
        ? ({ "data-testid": toSlug(id) } as const)
        : {};
}

